import { render, staticRenderFns } from "./DTimers.vue?vue&type=template&id=54dec2df&scoped=true"
import script from "./DTimers.vue?vue&type=script&lang=js"
export * from "./DTimers.vue?vue&type=script&lang=js"
import style0 from "./DTimers.vue?vue&type=style&index=0&id=54dec2df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dec2df",
  null
  
)

export default component.exports